export const NodeIds = {
  trigger: 'trigger',
  dropzone: 'dropzone',
  dropNode: 'dropNode',
  endOfFlow: 'end-of-flow',
  branchControl: 'branch-control',
  branchName: 'branch-name',
};

export const NodeTypeKeys = {
  triggerNodeType: 'triggerNodeType',
  dropzoneNodeType: 'dropzoneNodeType',
  dropNodeType: 'dropNodeType',
  endOfFlowNodeType: 'endOfFlowNodeType',
  displayWebContentNodeType: 'displayWebContentNodeType',
  sendEmailNodeType: 'sendEmailNodeType',
  branchControlNodeType: 'branchControlNodeType',
  branchNameNodeType: 'branchNameNodeType',
};
